module.exports = __webpack_public_path__ + "img/UTBEAR-5.db193cf3.jpg";